import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NotificationVariable } from '../../core/notification-editor';

@Component({
  selector: 'irembogov-iwb-variable-token-select',
  templateUrl: './variable-token-select.component.html',
})
export class VariableTokenSelectComponent {
  @Input() variables: NotificationVariable[] = [];
  @Input() label = 'Variables';
  @Input() buttonLabel = 'Insert variable';
  @Input() placeholder = 'Search global variables or form values';
  @Input() popupHelpText = 'Search and insert values into the current message.';
  @Input() iconClass = 'fa-code';
  @Output() tokenSelected = new EventEmitter<string>();

  selectedValue: string | null = null;
  searchTerm = '';
  isPickerOpen = false;

  get filteredGroups(): Array<{
    group: string;
    variables: NotificationVariable[];
  }> {
    const term = this.searchTerm.trim().toLowerCase();
    const groups = new Map<string, NotificationVariable[]>();

    this.variables
      .filter(variable => {
        if (!term) return true;
        return [variable.group, variable.label, variable.value]
          .filter(Boolean)
          .some(value => value.toLowerCase().includes(term));
      })
      .forEach(variable => {
        const group = variable.group || 'Other';
        groups.set(group, [...(groups.get(group) || []), variable]);
      });

    return [...groups.entries()].map(([group, variables]) => ({
      group,
      variables,
    }));
  }

  togglePicker(): void {
    this.isPickerOpen = !this.isPickerOpen;
    if (this.isPickerOpen) this.searchTerm = '';
  }

  closePicker(): void {
    this.selectedValue = null;
    this.searchTerm = '';
    this.isPickerOpen = false;
  }

  selectVariable(value: string | null | undefined): void {
    if (!value) {
      this.selectedValue = null;
      return;
    }
    this.tokenSelected.emit(value);
    this.selectedValue = null;
    this.searchTerm = '';
    this.isPickerOpen = false;
  }

  trackByGroup(_: number, group: { group: string }): string {
    return group.group;
  }

  trackByVariable(_: number, variable: NotificationVariable): string {
    return `${variable.group}:${variable.value}`;
  }
}
